module.exports = __webpack_public_path__ + "img/784.5e6a2cb5.jpg";